module.exports = __webpack_public_path__ + "static/img/pdf.3a998e41.png";